<template>
    <section class="building-reports container vue-lightbox">
            <report-filter @filterSubmit="filterSubmit" @clearFilter="clearFilter" :village_id="village_id"></report-filter>
            <section  v-if="reports.length > 0" class="building-reports__list owl-carousel">
              <figure class=" building-report-item" v-for="(image, index) in paginatedData" :class="{ 'building-report-item--active': index === activeItem}" @click.prevent="openGallery(image)">
                  <img :src='image.thumb + "?ver=11"'>
              </figure>

            </section>
            <div v-else>Результатов не найдено</div>
        <div v-if="reports.length > 0">
          <!--  <button class="btn button-rounded button-rounded--dark" @click="prevPage" :disabled="pageNumber==0">
                Назад
            </button>
            <button class="btn button-rounded button-rounded--dark" @click="nextPage" :disabled="pageNumber >= pageCount -1">
                Вперед
            </button>
            -->
        </div>
        <LightBox ref="lightbox"
                  :media="gallery"
                  :show-caption="false"
                  :show-light-box="false"
        ></LightBox>
    </section>
</template>
<script>
    import filter from "./filter";

    import LightBox from 'vue-image-lightbox'
    export default {
        components: {
            'ReportFilter':filter,
            'LightBox':LightBox,

        },
        props: [
            'village_id'
        ],
        computed: {
            pageCount(){
                let l = this.reports.length,
                    s = this.size;
                // редакция переводчика спасибо комментаторам
                return Math.ceil(l/s);
                // оригинал
                // return Math.floor(l/s);
            },
            paginatedData(){
                const start = this.pageNumber * this.size,
                    end = start + this.size;
                return this.reports.slice(start, end);
            }
        },
        data() {
            return {
                reports: [],
                activeItem: 0,
                pageNumber: 0,
                size:24,
                gallery: [
                  {
                    thumb: '',
                    src: ''
                  }
                ],
                index_reports:0,

            }
        },
        methods: {
          destroyOwlCarousel:function() {
            $('.building-reports__list').owlCarousel('destroy');
          },
          installOwlCarousel: function(){
            $('.building-reports__list').owlCarousel({
              dots:false,
              nav:false,
              margin:30,
              stagePadding: 50,
              responsive:{
                0:{
                  items:1,

                },
                768:{

                  items:2,

                },
                1024:{
                  items:3,

                },
                1200:{
                  items:4,

                }
              },
            });
          },
            clearFilter() {
                this.getReports();
                this.pageNumber = 0;
                this.activeItem = 0;
                this.index_reports = 0;
            },
            filterSubmit(form) {
              var vm = this;
              vm.destroyOwlCarousel();
                axios.get('/api/village/' + this.village_id +'/reports',{params:form})
                    .then((response) => {
                        this.reports = response.data;
                        this.pageNumber = 0;
                        this.activeItem = 0;
                        this.index_reports = 0;
                      Vue.nextTick(function(){
                        vm.installOwlCarousel();
                      }.bind(vm));
                    })
                    .catch((error) => {

                    })
            },
            getReports() {
              var vm = this;
                axios.get('/api/village/' + this.village_id +'/reports')
                    .then((response) => {
                        this.reports = response.data;
                        Vue.nextTick(function(){
                        vm.installOwlCarousel();
                      }.bind(vm));

                    })
                    .catch((error) => {

                    })
            },

            nextPage(){
                this.pageNumber++;
            },
            prevPage(){
                this.pageNumber--;
            },
            openGallery(image) {
                let index_reports = this.reports.indexOf(image);
                this.index_reports = index_reports;
                let index_chunk = this.paginatedData.indexOf(image);
                this.activeItem = index_chunk;
                var media = this.reports.map(function(item){
                    return {
                        thumb:item.thumb,
                        src:item.url
                    }
                });
                this.gallery = media;
                this.$refs.lightbox.showImage(this.index_reports);
            },
        },
        mounted() {
            this.getReports();
            console.log(window.innerWidth);
        }
    }
</script>